import React, {useEffect, useState} from 'react';
import {Button, Card, Checkbox, DatePicker, Form, Input, Modal, Radio, Space, Table, Tag} from 'antd';
import {useBoolean, useMount} from 'react-use';
import {Term, TermApi, TermStatus, UserApi, UserDto, UserRole} from '../../scaffold';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import CommonApiErrorHandler from '../../utils/HttpInstance';
import ImportUserExcel from '../../components/user/ImportExcel';
import Text from 'antd/lib/typography/Text';
import Flex from '../../components/Flex';
import DateFormat from '../../utils/DateFormat';
import TermStatusTag from '../../components/Term/TermStatusTag';
import moment, {Moment} from 'moment';

const {confirm} = Modal;

export default function ManageTermPage() {
  const [role, setRole] = useState<UserRole>(UserRole.教师);
  const listState = useOpenApiFpRequest(TermApi, TermApi.prototype.termListGet);
  const saveState = useOpenApiFpRequest(TermApi, TermApi.prototype.termSavePost);
  const exportSupervisor = useOpenApiFpRequest(TermApi, TermApi.prototype.termExportSupervisorGet);
  const exportJudge = useOpenApiFpRequest(TermApi, TermApi.prototype.termExportJudgeGet);
  const exportStudent = useOpenApiFpRequest(TermApi, TermApi.prototype.termExportStudentGet);
  function refresh() {
    listState.requestSync({});
  }
  useMount(() => {
    refresh();
  });
  const [isDialog, _isDialog] = useBoolean(false);
  const [name, setName] = useState('');
  const [beginDate, setBeginDate] = useState<Moment>();
  const [endDate, setEndDate] = useState<Moment>();
  const [status, setStatus] = useState(TermStatus.未开始);
  const [selectedTerm, setSelectedTerm] = useState<Term>();

  function save() {
    saveState
      .request({
        saveTermModel: {
          id: selectedTerm?.id,
          name,
          beginTime: beginDate?.format('YYYY-MM-DD') || '',
          endTime: endDate?.format('YYYY-MM-DD') || '',
          status,
        },
      })
      .then(() => {
        refresh();
        _isDialog(false);
      })
      .catch(CommonApiErrorHandler);
  }

  useEffect(() => {
    if (!selectedTerm) {
      setName('');
      setBeginDate(undefined);
      setEndDate(undefined);
      setStatus(TermStatus.未开始);
    } else {
      setName(selectedTerm.name || '');
      setBeginDate(moment(selectedTerm.beginTime));
      setEndDate(moment(selectedTerm.endTime));
      setStatus(selectedTerm.termStatus as any);
    }
  }, [selectedTerm]);

  return (
    <Card
      title={'批次设置'}
      extra={
        <Button
          onClick={() => {
            _isDialog(true);
          }}>
          添加批次
        </Button>
      }>
      <Table rowKey={'id'} dataSource={listState.data} size={'small'} bordered loading={listState.loading}>
        <Table.Column<Term> title={'批次名'} dataIndex={'name'} />
        <Table.Column<Term> title={'状态'} render={(_, i) => i.termStatus && <TermStatusTag status={i.termStatus} />} />
        <Table.Column<Term> title={'开始时间'} render={(_, i) => DateFormat.simple(i.beginTime)} />
        <Table.Column<Term> title={'结束时间'} render={(_, i) => DateFormat.simple(i.endTime)} />
        <Table.Column<UserDto>
          title={'操作'}
          render={(_, item) => (
            <Space>
              <a
                onClick={() => {
                  _isDialog(true);
                  setSelectedTerm(item);
                }}>
                编辑
              </a>
              <a
                onClick={() => {
                  exportSupervisor
                    .request({id: item.id || 0})
                    .then(res => {
                      res.url && window.open(res.url, '_blank');
                    })
                    .catch(CommonApiErrorHandler);
                }}>
                导出督导费用
              </a>
              <a
                onClick={() => {
                  exportJudge
                    .request({id: item.id || 0})
                    .then(res => {
                      res.url && window.open(res.url, '_blank');
                    })
                    .catch(CommonApiErrorHandler);
                }}>
                导出盲审费用
              </a>
              <a
                onClick={() => {
                  exportStudent
                    .request({id: item.id || 0})
                    .then(res => {
                      res.url && window.open(res.url, '_blank');
                    })
                    .catch(CommonApiErrorHandler);
                }}>
                导出学生统计
              </a>
            </Space>
          )}
        />
      </Table>
      <Modal title={'批次设置'} visible={isDialog} onCancel={() => _isDialog(false)} confirmLoading={saveState.loading} onOk={save}>
        <Form layout={'vertical'}>
          <Form.Item label={'批次名'}>
            <Input value={name} onChange={e => setName(e.target.value)} placeholder={'如 第一批、2021 年第一批'} />
          </Form.Item>
          <Flex>
            <Form.Item label={'开始时间'} className={'m-r-20'}>
              <DatePicker value={beginDate} onChange={setBeginDate as any} placeholder={'选择开始时间（仅用于提示学生）'} />
            </Form.Item>
            <Form.Item label={'截止时间'}>
              <DatePicker value={endDate} onChange={setEndDate as any} placeholder={'选择截止时间（仅用于提示学生）'} />
            </Form.Item>
          </Flex>
          <Form.Item label={'状态'}>
            <Radio.Group value={status} onChange={e => setStatus(e.target.value)}>
              <Radio value={TermStatus.未开始}>未开始</Radio>
              <Radio value={TermStatus.进行中}>进行中</Radio>
              <Radio value={TermStatus.已结束}>已结束</Radio>
            </Radio.Group>
          </Form.Item>
        </Form>
      </Modal>
    </Card>
  );
}
